import type { Note } from '@/types/note';

export function nextZIndex(notes: readonly Note[] | Readonly<Record<string, Note>>): number {
  const values: readonly Note[] = Array.isArray(notes) ? notes : Object.values(notes);
  if (values.length === 0) return 1;
  let max = 0;
  for (const n of values) {
    if (n.zIndex > max) max = n.zIndex;
  }
  return max + 1;
}
